const openLink = (link) => {
  window.open(link, "blank");
};

export default openLink;
